import Route from '@ember/routing/route';

class Error404Route extends Route {

}

export default Error404Route;
